import React, { Component } from "react";
import PropTypes from "prop-types";
import { RegistrationShape } from "../../utils";
import RightDrawer from "../RightDrawer";
import RegistrationFlags from "./RegistrationFlags";
import EditRegistration from "./EditRegistration";

class QueueItemDrawer extends Component {
  constructor(props) {
    super(props);
    this.handleGetDrawerVisible = this.handleGetDrawerVisible.bind(this);
  }

  handleGetDrawerVisible() {
    return !!this.props.editQueueItem;
  }

  render() {
    const { onCompleteEditQueueItem, editQueueItem } = this.props;

    return (
      <RightDrawer
        className="queue-item-drawer"
        onToggleDrawer={onCompleteEditQueueItem}
        onCloseDrawer={onCompleteEditQueueItem}
        getDrawerVisible={this.handleGetDrawerVisible}
        title="Registration Flags"
      >
        {editQueueItem
          ? <div>
              <EditRegistration />
              <RegistrationFlags />
            </div>
          : <div />}
      </RightDrawer>
    );
  }
}

QueueItemDrawer.propTypes = {
  editQueueItem: RegistrationShape,
  onCompleteEditQueueItem: PropTypes.func.isRequired
};

QueueItemDrawer.defaultProps = {
  editQueueItem: null
};

export default QueueItemDrawer;



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/QueueItemDrawer.jsx